import { IPhanGiaoVienActionTypes } from "../../action-types/tkb/IPhanGiaoVienActions";
import { IPhanGiaoVienReducer } from "../../reducer-model/tkb/IPhanGiaoVienReducer";
const iniState: IPhanGiaoVienReducer = {
    giaoVienSelectedId: ""
}

export const phanGiaoVienReducer = (state: IPhanGiaoVienReducer = iniState, action: IPhanGiaoVienActionTypes): IPhanGiaoVienReducer => {
    switch (action.type) {
        case "PHAN_GIAO_VIEN_CHANGE_SELECTED_GIAOVIEN_ID":
            return {
                ...state,
                giaoVienSelectedId: action.payload
            }

        default:
            return { ...state };
    }
}